import request from '@/utils/request'

export function getList(data) {
  return request({
    url: '/user/ai/ai/aiChatType/list',
    method: 'post',
    data
  })
}

export function getUploadCaseFlag(data) {
  return request({
    url: '/user/user/user/userChatContent/getUploadCaseFlag',
    method: 'post',
    data
  })
}

export function getCaseTypeList(data) {
  return request({
    url: '/user/user/user/userChatContent/getCaseTypeList',
    method: 'post',
    data
  })
}

export function getUperTypeList(data) {
  return request({
    url: '/user/user/user/userChatContent/getStyleTypeList',
    method: 'post',
    data
  })
}



export function getCaseLabelList(data) {
  return request({
    url: '/user/user/user/userChatContent/getCaseLabelList',
    method: 'post',
    data
  })
}





export function uploadCase(data) {
  return request({
    url: '/user/user/user/userChatContent/uploadCase',
    method: 'post',
    data
  })
}

export function getCaseInfoPageList(data) {
  return request({
    url: '/user/user/user/userChatContent/getCaseInfoPageList',
    method: 'post',
    data
  })
}









// WEBPACK FOOTER //
// ./src/api/ai/userAiChatType.js